// Who is looking at a public page: the header and footer swap the log in /
// sign up links for the visitor's dashboard once signed in, because the
// signed-in route set has no /login, /signup or /login-org.
export const signedIn = () => !!localStorage.getItem("accessToken");
export const dashboardPath = () => (localStorage.getItem("organizer") ? "/organizer-dashboard" : "/");

// React Router leaves the page where it is when a link points at the page and
// #section already showing, so a repeated click on "Results" or "Pricing"
// would do nothing; this scrolls to the section itself in that case.
export const scrollIfSamePage = (to) => () => {
  const [path, hash] = String(to).split("#");
  if (!hash || (path || "/") !== window.location.pathname) return;
  const el = document.getElementById(hash);
  if (el) el.scrollIntoView({ block: "start" });
};
